var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0C7.61131 0 0 7.61129 0 17.0001C0 26.3893 7.61131 34 16.9999 34C26.3895 34 34 26.3893 34 17.0001C34 7.6119 26.3895 0.000812018 16.9997 0.000812018L16.9999 0ZM24.7959 24.519C24.4914 25.0184 23.8378 25.1768 23.3384 24.8702C19.347 22.4321 14.3223 21.88 8.40484 23.232C7.83461 23.3619 7.26621 23.0046 7.13629 22.4342C7.00576 21.8637 7.36162 21.2953 7.93327 21.1654C14.409 19.6859 19.9637 20.3229 24.4447 23.0614C24.9441 23.368 25.1025 24.0196 24.7959 24.519ZM26.8767 19.8901C26.493 20.5137 25.677 20.7106 25.0538 20.327C20.4842 17.5182 13.5186 16.7047 8.11374 18.3454C7.41278 18.5572 6.67243 18.1621 6.45969 17.4623C6.24857 16.7614 6.64381 16.0224 7.34356 15.8093C13.5174 13.9359 21.1927 14.8434 26.4402 18.0681C27.0635 18.4518 27.2604 19.2677 26.8767 19.8901ZM27.0553 15.0699C21.5763 11.8155 12.5367 11.5163 7.30559 13.104C6.46558 13.3588 5.57724 12.8846 5.32268 12.0445C5.06812 11.2041 5.54192 10.3163 6.38255 10.061C12.3875 8.23797 22.3701 8.59019 28.6781 12.335C29.4353 12.7835 29.683 13.7593 29.2344 14.5139C28.7878 15.2695 27.8093 15.5186 27.0562 15.0699H27.0553Z",
    fill: "#1ED760"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8af7661.svg";
export { ForwardRef as ReactComponent };